export default "__VITE_ASSET__NkmioxNj__"